import styles from './TabSectionContent.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class TabSectionContent extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get variant(): string {
        return this.dataset.variant ?? 'vertical';
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(`base-grid`);
        container.innerHTML = `
            <div class="content">
                <div class="body"></div>
                <div class="cta">
                    <slot name="cta"></slot>
                </div>
            </div>
            <div class="tiles">
                <slot name="tiles"></slot>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneDefaultSlotContentIntoContainer(container.querySelector('.body'), false);
        return container;
    }

}

customElements.define('nxt-tab-section-content', TabSectionContent);
